document.addEventListener('change', function(event) {
  const target = event.target;

  if (target.classList.contains('select__select')) {
    setTimeout(() => {
        const productForm = document.querySelector("[bss-b2b-main-product-form]");
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
        document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
    }, 500);
  }
});